
export default {
  name: "commonlist",
  props: {},
  //inject: ["reload"],
  data() {
    return {
      //固定查询所用参数
      queryinfo: {}, //查询条件
      pageinfo: {
        currPage: 0, //当前页码
        rowsPerPage: 15, //每页展示数量
        count: 0, //记录总数
      }, //分页信息
      listAction: "", //报表展示的路径
      tableData: [], //报表结果集

      //固定新增所用参数
      loadRouterPath: "", //新增单据的页面路径

      //固定删除所用参数
      delBillids: "", //批量删除的单据ID
      deleteAction: "", //批量删除的路径

      //固定其他参数
      multipleSelection: "", //复选框选中行对象
      keyname: "id", //默认单据主键billid
      currmoduid: "", //模块ID
      applydeptid: "", //发起部门
      tab: "", //区别标签
      applyareacode: "", //当前用户所属地区的编码

      // colon:"：",
    };
  },
  methods: {
    /**
     * 公用查询方法
     */
    async dopagequery() {
      //查询参数
      let portalflag = this.$route.query.portalflag;
      if(this.isNotNullOrEmpty(portalflag)){
        this.queryinfo["portalflag"]=portalflag;
      }
      let oQuery = {
        queryinfo: this.queryinfo,
        pageinfo: this.pageinfo,
        tab: this.tab,
      };
      if (this.dopagequeryBefore(oQuery)) {
        await this.axios.post(this.listAction, oQuery).then(({ data }) => {
          this.currmoduid = data.data.sys_moduid;
          this.tableData = data.data.record;

          if (this.isNotNullOrEmpty(data.data.applyareacode)) {
            this.applyareacode = data.data.applyareacode;
          }

          //设置分页信息
          this.pageinfo.currPage = data.data.pageinfo.current;
          this.pageinfo.rowsPerPage = data.data.pageinfo.length;
          this.pageinfo.count = data.data.pageinfo.count;
          this.pageinfo.totalNum =  data.data.pageinfo.total;
          this.dopagequeryAfter(oQuery, data);
        });
      }
    },
    /**
     * 公用查询方法(执行前调用方式)
     */
    dopagequeryBefore(oQuery) {
      return true;
    },
    /**
     * 公用查询方法(执行后调用方式)
     */
    async dopagequeryAfter(oQuery, data) {},
    /**
     * 新增
     */
    async doAdd() {
      let oQuery = {};
      //申请部门不能为空,(无需校验承办部门信息时请设置applydeptid为非空值 如 undefined)
      if (this.applydeptid == "") {
        this.$message({
          type: "info",
          message: this.$t("commonlist.chooseapplydept"),
        });
        console.log(222);
        return false;
      } else {
        oQuery.applydeptid = this.applydeptid;
      }
      if (await this.doAddBefore(oQuery)) {
        console.log("doAdd", this.loadRouterPath);
        // alert(oQuery.year);
        this.openWin(this.loadRouterPath, oQuery);
      }
      this.dialogVisible = true;
    },
    /**
     * 公用新增方法(执行前调用方式)
     */
    doAddBefore(oQuery) {
      return true;
    },
    /**
     * 公用编辑方法
     */
    doEdit(val) {
      let oQuery = {};
      oQuery[this.keyname] = val;
      if (this.doEditBefore(oQuery)) {
        this.openWin(this.loadRouterPath, oQuery);
      }
    },
    /**
     * 公用编辑方法(执行前调用方式)
     */
    doEditBefore: function (oQuery) {
      return true;
    },
    /**
     * 公用批量删除方法
     */
    async doDel() {
      console.log(
        "2019年12月12日10:32:05 commonlist.vue[描述]——[this.multipleSelection] :",
        this.multipleSelection
      );

      let oQuery = {};

      //解析删除的单据billid
      if (
        this.multipleSelection != undefined &&
        this.multipleSelection != null &&
        this.multipleSelection != ""
      ) {
        this.multipleSelection.forEach((row) => {
          this.delBillids += row[this.keyname] + ";";
        });
      }
      oQuery.delBillids = this.delBillids;

      if (this.doDelBefore(oQuery)) {
        //校验删除单据不能为空
        if (
          this.delBillids == undefined ||
          this.delBillids == null ||
          this.delBillids == ""
        ) {
          this.$message({
            type: "info",
            message: this.$t("commonlist.choosedelbill"),
          });
          return false;
        }

        this.tipCustomConfirm("default", this.$t("commonlist.msg"), "").then(
          () => {
            this.axios.post(this.deleteAction, oQuery).then(({ data }) => {
              try {
                this.dopagequery();
                this.doDelAfter(oQuery, data);
              } catch (error) {
                () => {};
              }
            });
          }
        );
      }
    },
    /**
     * 公用批量删除方法(执行前调用方式)
     * oQuery : 后端交互请求参数对象
     */
    doDelBefore(oQuery) {
      return true;
    },
    /**
     * 公用批量删除方法(执行后调用方式)
     * oQuery : 后端交互请求参数对象
     * data ：后端返回数据
     */
    async doDelAfter(oQuery, data) {
      this.reload();
    },
    /**
     * 公用复选框选中方法
     */
    doSelectionChange(val) {
      this.multipleSelection = val;
    },
    /**
     * 公用页面切换方法
     */
    doPageChange(oPage) {
      this.pageinfo.currPage = oPage.page_index;
      this.pageinfo.rowsPerPage = oPage.page_limit;
      this.dopagequery();
    },
    /**
     * 初始化复选框选中
     */
    checkboxT(row) {
      if (row.isDelFlag == 1) {
        return true;
      }
      //此处应为false
      return false;
    },
    /**
     * 重置查询表单
     */
    resetForm() {
      this.queryinfo = {};
    },
  },
};



// WEBPACK FOOTER //
// ./src/pcpage/hr/common/commonlist.vue